module.exports = __webpack_public_path__ + "static/img/hover-iocn4.ef39e11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn4.svg
// module id = x2rl
// module chunks = 0